/**
 * mk-material-center
 * unknown
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @description v1WxopenCustomerDetailGet参数
  * @property `companyId` 公司id
  * @property `unionId` unionid
  */
export interface Paramsv1WxopenCustomerDetailGet {
  // queryParams
  /**
   * 公司id
   */
  companyId: string;
  /**
   * unionid
   */
  unionId: string;
}
/**
  */
export type ParamsBodyv1WxopenCustomerUpdateMobilePut = models.V1WxopenCustomerUpdateMobileBody;

export class WxminiCustomerApi {
  protected $basePath = '/material/center'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary GetExternalDetail 通过unionid查询是否有手机号
   * @param params Paramsv1WxopenCustomerDetailGet
   
   * @param opt ajax config
   * @returns models.V1WxopenCustomerDetail
   */
  public v1WxopenCustomerDetailGet = (
    params: Paramsv1WxopenCustomerDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1WxopenCustomerDetail>  => {
    const path = '/v1/wxopen/customer/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('unionId' in params) p.query.unionId = params.unionId;
    ajax.check(params.unionId, 'unionId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary UpdateMobileByUnionID 通过unionid更新moblie
   
   * @param data: ParamsBodyv1WxopenCustomerUpdateMobilePut
   * @param opt ajax config
   * @returns models.V1PosterDownloadPosterQrcodes
   */
  public v1WxopenCustomerUpdateMobilePut = (
    
    data: ParamsBodyv1WxopenCustomerUpdateMobilePut,opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1PosterDownloadPosterQrcodes>  => {
    const path = '/v1/wxopen/customer/updateMobile';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'PUT',
      url,
      ...p
    });
  }
}

export default new WxminiCustomerApi();